import checkResponse from "../helpers/responseService"

export default {
  getActiveSalesManagers() {
    return axios.get('/sales-managers/list')
      .then(response => checkResponse(response))
  },
}



// WEBPACK FOOTER //
// ./resources/js/services/salesManagersDataService.js